/*
 * @创建人: 但志强
 * @修改人: 但志强
 * @描述: 请输入描述
 * @创建时间: 2019-07-12 17:04:48
 * @修改时间: 2019-08-02 16:27:24
 */

/**
 * 系统管理公共接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务apiasdasd
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private systemId :SystemIdService,
     private httpClient: HttpClient,
   ) {
   }

   //#region 公共
  /**
   * 菜单列表
   * @param param
   * @returns {Observable<any>}
   */
  queryFunctionsByUserId(param, userId) {
    const url = this.prefix + 'function/queryFunctionsByUserId?userId=' + userId+"&systemId="+this.systemId.getSystemId();
    return this.http.Post(url, param);
  }

  /**
   * 加载toolbar按钮
   * @param param
   * @returns {Observable<any>}
   */
  queryButtonsByUri(pathname, systemId, param) {
    const url = this.prefix + 'function/queryButtonsByUri?uri=' + pathname + '&systemId=' + systemId;
    return this.http.Post(url, param);
  }

  /**
   * 关联查询
   * @param param
   * @returns {Observable<any>}
   */
  queryUserByOrganizeId(param) {
    const url = this.prefix + 'user/queryUserByOrganizeId';
    return this.http.Post(url, param);
  }

  /**
   * 复选页面(角色管理的权限设置,功能权限)
   * @param param
   * @returns {Observable<any>}
   */
  queryRoleFunctionByFk(param) {
    const url = this.prefix + 'roleFunction/queryByFk';
    return this.http.Post(url, param);
  }

  /**
   * 复选页面(用户管理的权限管理,功能权限)
   * @param param
   * @returns {Observable<any>}
   */
  queryRoleFunctionsByUserId(systemId, userId) {
    const url = this.prefix + 'roleFunction/queryRoleFunctionsByUserId?systemId=' + systemId + '&userId=' + userId;
    return this.http.Post(url, systemId);
  }
  
  /**
   * 查询省份信息
   * @returns {Observable<any>}
   */
  getPronvinceList() {
    const url = this.prefix + 'region/getProvinceList';
    return this.http.Post(url, null);
  }
  /**
   * 查询城市信息
   * @param param
   * @returns {Observable<any>}
   */
  getCityList(param) {
    const url = this.prefix + 'region/getCityList?provinceName=' + param;
    return this.http.Post(url, null);
  }

  //#endregion


}
